export class PdfResponse {
    data: any;
}